import produce from "immer";
import IReceiptsReturnsReducer from "models/IReceiptsReturnsReducer";
import { actionTypes } from "./actions";
import { receiptReturnSorting as defaultSorting } from "constants/sorting";

const initialState: IReceiptsReturnsReducer = {
  isLoading: false,
  isLoaded: false,
  items: [],
  meta: {
    defaultSorting
  },
  error: null
};

export default (state = initialState, action: any) =>
  // @ts-ignore
  produce(state, draftState => {
    switch (action.type) {
      case actionTypes.GET_RECEIPTS_RETURNS_SUCCESS:
        draftState.items = action.payload;
        draftState.meta = action.meta;
        break;
      case actionTypes.GET_RECEIPTS_RETURNS_FAILURE:
        draftState.error = action.error;
        break;
    }
  });
